<pop-error-wrapper>
  <h1 title
      translate="ERROR.PERMISSION_SHORT"></h1>
  <p description
     translate="ERROR.PERMISSION"></p>
  <button action
          class="pl-button"
          (click)="returnAction()"
          translate="MODAL.BACK"></button>
</pop-error-wrapper>
